import React from 'react';
import { Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ActionButtonsProps } from '../../../@types/transactions';

const ActionButtons: React.FC<ActionButtonsProps> = ({
  isSubmitting,
  isEdit,
  disableSubmit,
  onClose,
  copiedInfo
}) => (
  <Stack direction="row" justifyContent="space-between">
    <Typography variant="body2" color="textSecondary">
      {copiedInfo?.copied && `Initially copied from ticket id ${copiedInfo?.sourceId}`}
    </Typography>
    <Stack spacing={2} direction="row">
      <LoadingButton variant="outlined" color="primary" onClick={onClose} disabled={isSubmitting}>
        Close
      </LoadingButton>
      <LoadingButton
        type="submit"
        variant="contained"
        loading={isSubmitting}
        disabled={disableSubmit}
      >
        {!isEdit ? 'Create Transaction' : 'Save Changes'}
      </LoadingButton>
    </Stack>
  </Stack>
);

export default ActionButtons;
